export const colorFormat = {
  Purple: "#590aa3",
  Blue: "#007AFF",
  LightPurple: "#f7e6ff",
  Red_Light: "#FFEAEA",
  Red_Dark: "#dc2626",
  Normal_Red: "#E22A2A",
  Green: "#16a34a",
  FilterBlueImage:
    "invert(39%) sepia(94%) saturate(861%) hue-rotate(183deg) brightness(91%) contrast(104%)",
  Dark_Blue: "#00035B",
  Black: "#000000",
  Yellow: "#ca8a04",
  CardBorder: "#cacbcc",
  Orange: "#d4591c",
  Gold: "#BD801D",
  Gray: "#909090",
  LightOrange: "#E77117",
};
